module.exports = ".mat-table {\n  flex: 1 1 100%;\n  height: 240px;\n  overflow: auto;\n}\n\n.mat-form-field {\n  width: 40%;\n}"